import SheetFiltersItem from "@/common/components/SheetFiltersItem";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { dashboardFilters } from "@/features/company/constants/dashboards/dashboardFilters.constant";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEquipmentCategories } from "@/features/equipments/hooks/useEquipmentCategories";
import { EquipmentCategoryData } from "@/features/equipments/types/equipments.type";

const DashboardFilterEquipmentCategorySheet = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch, instantSearch] = useDebounce('');

  const {
    data: equipmentCategoriesOptions,
  } = useEquipmentCategories({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<EquipmentCategoryData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <SheetFiltersItem
      label={dashboardFilters[DashboardFilters.EquipmentCategory]}
      value={filters[DashboardFilters.EquipmentCategory]?.value || ''}
      options={[{ label: 'Todas', value: '' }, ...equipmentCategoriesOptions]}
      onChange={(value) => setFilters((prev) => ({ ...prev, [DashboardFilters.EquipmentCategory]: value }))}
      instantSearch={instantSearch}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterEquipmentCategorySheet;
